import parse from 'html-react-parser';
import { useState, ReactNode } from 'react';
import { Card as ShadCard, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CardProps {
  title: string | ReactNode;
  children: ReactNode;
}

function Card({ title, children }: CardProps) {
  return (
    <ShadCard className="mb-4">
      <CardHeader className="py-3 px-4 border-b">
        <CardTitle className="text-sm font-semibold text-primary">
          {typeof title === 'string' ? parse(title) : title}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        {children}
      </CardContent>
    </ShadCard>
  );
}

interface CollasableCardProps {
  title: string;
  children: ReactNode;
}

function CollasableCard({ title, children }: CollasableCardProps) {
  const [open, setOpen] = useState(true);

  return (
    <ShadCard className="mb-4">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-4 py-3 border-b hover:bg-accent/50 transition-colors rounded-t-lg"
      >
        <span className="text-sm font-semibold text-primary">{title}</span>
        {open
          ? <ChevronDown className="h-4 w-4 text-muted-foreground" />
          : <ChevronRight className="h-4 w-4 text-muted-foreground" />
        }
      </button>
      {open && (
        <CardContent className="p-4">
          {children}
        </CardContent>
      )}
    </ShadCard>
  );
}

export default Card;
export { Card, CollasableCard };
